<template>
  <li class="order-list-item">
    <router-link class="order-details-link" :to="{name: 'order-details', params: {id: orderNumber}}">
      <div class="header">
        <div class="row">
          <div class="order-date small-6 column">
            {{$t('order.label.order-date')}}<br>
            <strong>{{formatDate(orderDate)}}</strong>
          </div>
          <div class="small-6 column">
            <div class="clearfix">
              <div class="float-right"><status-chips v-bind:status="orderStatus"></status-chips></div>
              <div class="delivery-flags float-right">
                <ui-icon icon="warning" class="notif-warning-color" v-if="deliveryDateHasChanged"></ui-icon>
                <ui-icon icon="info" class="notif-info-color" v-if="deliveryDateIsDifferent"></ui-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content lateral-sub-padding">
        <div class="row">
          <div class="small-5 large-3 column">{{$t('order.label.order-number')}}</div>
          <div class="small-7 large-9 column"><strong>{{orderNumber}}</strong></div>
        </div>
        <div class="row" v-if="orderRef">
          <div class="small-5 large-3 column">{{$t('order.label.customer-reference')}}</div>
          <div class="small-7 large-9 column"><strong>{{orderRef}}</strong></div>
        </div>
        <div class="row delivery-date">
          <div class="small-5 large-3 column">{{$t('order.label.estimed-delivery-date')}}</div>
          <div class="small-7 large-9 column" v-bind:class="{ 'notif-warning-color': deliveryDateHasChanged, 'notif-info-color': deliveryDateIsDifferent }" >
            <div>
              <strong>
                <span v-if="deliveryDateFrom && !deliveryDateTo">{{ $t('order.label.estimed-delivery-date-on', {onDate: formatDate(deliveryDateFrom)}) }}</span>
                <span v-if="deliveryDateFrom && deliveryDateTo">{{ orderDeliveryDate(deliveryDateFrom, deliveryDateTo) }}</span>
              </strong>
            </div>
            <div class="delivery-messages" v-if="deliveryDateIsDifferent || deliveryDateHasChanged">
              <div class="notif-warning-color" v-if="deliveryDateHasChanged">{{$t('order.label.estimed-delivery-date-has-changed')}}</div>
              <div class="notif-info-color" v-if="deliveryDateIsDifferent">{{$t('order.label.estimed-delivery-date-is-different')}}</div>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
  import moment from 'moment'
  import StatusChips from 'components/StatusChips'

  function formatDate (date) {
    return date ? moment(date).format('DD.MM.YYYY') : null
  }

  export default {
    name: 'order-list-item',
    props: [
      'order-number',
      'order-ref',
      'order-date',
      'order-status',
      'delivery-date-from',
      'delivery-date-to',
      'delivery-date-is-different',
      'delivery-date-has-changed'
    ],
    components: {
      'status-chips': StatusChips
    },
    methods: {
      formatDate: formatDate,
      orderDeliveryDate: function (deliveryDateFrom, deliveryDateTo) {
        if (deliveryDateFrom === deliveryDateTo) {
          return this.$t('order.label.estimed-delivery-date-on', { onDate: formatDate(deliveryDateFrom) })
        }
        else {
          return this.$t('order.label.estimed-delivery-date-from-to', { fromDate: formatDate(deliveryDateFrom), toDate: formatDate(deliveryDateTo) })
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  .order-list-item {
    background-color: $light;
    border-top: 1px solid $grey-50;

    /* Medium and up */
    @include breakpoint(large) {
      border-left: 1px solid $grey-50;
      border-right: 1px solid $grey-50;

      &:last-of-type {
        border-bottom: 1px solid $grey-50;
      }
    }

    > a.order-details-link {
      // position: relative;
      display: block;
      text-decoration: none;
    }

    > a.order-details-link:link,
    > a.order-details-link:visited,
    > a.order-details-link:hover,
    > a.order-details-link:active {
      color: inherit;
    }

    .notif-info-color {
      color: $warning;
    }

    .notif-warning-color {
      color: $danger;
    }

    .notif-info-color.notif-warning-color {
      color: $danger;
    }

    .header {
      background-color: $grey-10;
      padding: 7px 0;

      .order-date strong {
        font-size: 15px;
        font-weight: normal;
        line-height: 1.5;
      }

      .status-chips {
        margin-top: 7px;
      }

      .delivery-flags {
        margin-right: 2px;
        margin-top: 4px;

        .ui-icon {
          font-size: 26px;
          margin-right: 2px;
        }
      }
    }

    .content {
      padding-top: 15px;
      padding-bottom: 15px;
      line-height: 1.5;

      .delivery-messages {
        font-size: 9px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// OrderListItem.vue?ee5dd11c